import { createFileRoute } from '@tanstack/react-router'

import AppearanceSection from 'pages/Settings/AppearanceSection'

export const Route = createFileRoute('/_auth/settings/appearance')({
  component: AppearanceSection,
})
